import { HostActionType as e } from "../types/HostActionType.mjs";
import { HostActionIntent as t } from "../types/HostActionIntent.mjs";
import { HostActionFacetKind as n } from "../types/HostActionFacet.mjs";
import { HostActionFigureCaption as r } from "../types/HostActionFigure.mjs";
import { HostActionTargetKind as i } from "../types/HostActionTarget.mjs";
import { BookingModificationMode as a, getBookingSettlementCurrency as o } from "@maat/api-booking/types";
import { parseAmount as s } from "@maat/currency";
//#region src/mappers/toModificationActions.ts
var c = (c, l) => c.map((c) => {
	let u = l.get(c.booking_id), d = c.mode === a.Extend, f = s(c.delta_amount_egp), p = d ? e.ExtensionRequest : e.DateChangeRequest;
	return {
		id: `${p}:${c.id}`,
		type: p,
		intent: t.Decision,
		imageUrl: u?.metadata?.cover_image_url,
		avatarName: u?.metadata?.guest_name,
		params: { guest: u?.metadata?.guest_name },
		object: u?.metadata?.listing_title,
		facets: [{
			kind: n.StayChange,
			checkIn: c.new_check_in,
			checkOut: c.new_check_out,
			previousCheckIn: c.old_check_in,
			previousCheckOut: c.old_check_out
		}],
		figure: f === void 0 || f === 0 ? void 0 : {
			amount: f,
			currency: o(u ?? null),
			caption: r.Delta,
			signed: !0
		},
		expiresAt: c.expires_at ?? void 0,
		createdAt: c.created_at,
		weight: Math.abs(f ?? 0),
		target: {
			kind: i.BookingDetail,
			id: c.booking_id
		}
	};
}), l = (r, a) => r.map((r) => {
	let o = a.get(r.booking_id);
	return {
		id: `${e.OfferAwaitingPayment}:${r.id}`,
		type: e.OfferAwaitingPayment,
		intent: t.Waiting,
		imageUrl: o?.metadata?.cover_image_url,
		avatarName: o?.metadata?.guest_name,
		params: { guest: o?.metadata?.guest_name },
		object: o?.metadata?.listing_title,
		facets: [{
			kind: n.Stay,
			checkIn: r.new_check_in,
			checkOut: r.new_check_out
		}],
		expiresAt: r.expires_at ?? void 0,
		createdAt: r.created_at,
		target: {
			kind: i.BookingDetail,
			id: r.booking_id
		}
	};
});
//#endregion
export { c as toModificationActions, l as toOfferAwaitingPaymentActions };
